import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function kategoriUnsur(unsur_no) {
  if (unsur_no <= 4) return { kode: "A", label: "MENTAL ROHANI" };
  if (unsur_no <= 6) return { kode: "B", label: "MENTAL IDEOLOGI" };
  return { kode: "C", label: "MENTAL KEJUANGAN" };
}

export function kriteriaWarna(kriteria) {
  switch (kriteria) {
    case "BS": return "text-emerald-700 bg-emerald-50 border-emerald-200";
    case "B":  return "text-blue-700 bg-blue-50 border-blue-200";
    case "C":  return "text-amber-700 bg-amber-50 border-amber-200";
    case "K":  return "text-red-700 bg-red-50 border-red-200";
    default:   return "text-slate-700 bg-slate-50 border-slate-200";
  }
}
